import axios from "axios";
import { SIGN_OUT } from "../../store/Login/types";
import { store } from "../../store/storeConfiguration";
import { toast } from "react-toastify";
import { toastProperties } from "../../commons/Toast/Toaster";

export const customAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

customAxios.interceptors.request.use(
  function (config) {
    let token = store.getState()?.sessionState?.token; // taking token
    config.headers.Accept = "application/json";
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

customAxios.interceptors.response.use(
  (response) => {
    if (response?.data?.code === 200) {
      return response;
    } else {
      toast.error(
        response?.data?.error && response?.data?.error,
        toastProperties
      );
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
export const apiCall = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

apiCall.interceptors.request.use(
  function (config) {
    let token = store.getState()?.sessionState?.token; // taking token
    config.headers.Accept = "application/json";
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiCall.interceptors.response.use(
  (response) => {
    if (response?.data?.code === 200) {
      return response;
    } else {
      toast.error(
        response?.data?.error && response?.data?.error,
        toastProperties
      );
      return response;
    }
  },
  (error) => {
    if (error.response !== undefined) {
      console.log(error.response);
      if (error.response.status === 400 || error.response.status == 400) {
        toast.error(
          error.response.data ? error.response.data.error : "Forbidden Access",
          toastProperties
        );
        return Promise.reject(error.response);
      }
      if (error.response.status === 404) {
        toast.error(
          error.response.data ? error.response.data.error : "Bad Request"
        );
      }
      if (error.response.status === 401) {
        toast.error(
          error.response.data
            ? error.response.data.error
            : "Unauthorised Access - invalid credentials!!",
          toastProperties
        );
        localStorage.clear();
        sessionStorage.clear();
        store.dispatch({ type: SIGN_OUT, payload: false });
        // history.push("./login");
        window.history.pushState("", "", "./login");
      }
      if (error.response.status === 403) {
        toast.error(
          error.response.data ? error.response.data.error : "Forbidden Access",
          toastProperties
        );
      }
      if (error.response.status === 500) {
        toast.error(
          error.response.data
            ? error.response.data.error != ""
              ? error.response.data.error
              : "We are facing system issue. Please try again later."
            : "",
          toastProperties
        );
      }
    } else {
      toast.error("Bad Gateway", toastProperties);
    }
  }
);
